import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=28bfe932&scoped=true"
import script from "./FilterDropdown.vue?vue&type=script&lang=js"
export * from "./FilterDropdown.vue?vue&type=script&lang=js"
import style1 from "./FilterDropdown.vue?vue&type=style&index=1&id=28bfe932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfe932",
  null
  
)

export default component.exports